import FJToolbarButton from "./FJToolbarButton";
import InSvg from "../../../icon/in.svg";
import OutSvg from '../../../icon/out.svg'
import FJViewConstant from "../../../constant/FJViewConstant";
import FJLocalStore from "../../../store/FJLocalStore";
import React, {memo} from "react";

const itemStyle = {marginRight: 6};

function FJSlotButtonGroup(props) {
  let {showType, toggleIntroPanel, toggleOutroPanel} = props;
  return (
    <>
      <FJToolbarButton icon={InSvg}
                       style={itemStyle}
                       active={showType === FJViewConstant.RESOURCES_ANIMATION_INTRO}
                       text={FJLocalStore._('enter-effect')}
                       onClick={toggleIntroPanel}
      />
      <FJToolbarButton icon={OutSvg}
                       style={itemStyle}
                       active={showType === FJViewConstant.RESOURCES_ANIMATION_OUTRO}
                       text={FJLocalStore._('exit-effect')}
                       onClick={toggleOutroPanel}
      />
    </>
  );
}

export default memo(FJSlotButtonGroup);